<script>
import CheckConnStatus from './CheckConnStatus.vue';
import CommonWhatsappAPI from '../channels/commonWhatsapp/api';
import CommonWhatsappForm from '../channels/commonWhatsapp/CommonWhatsappForm.vue';
import { useAlert } from 'dashboard/composables';

export default {
  components: {
    CheckConnStatus,
    CommonWhatsappForm,
  },
  props: {
    inbox: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  data() {
    return {
      defaultPlayer: '',
      denyWppConn: false,
    };
  },
  mounted() {
    this.getCurrentPlayer();
  },
  methods: {
    onRerenderDisconnected() {
      if (
        this.inbox.player !== this.defaultPlayer &&
        (!this.inbox.player || this.inbox.player === 'wppconnect')
      ) {
        this.denyWppConn = true;
      }
    },
    async onRerender() {
      const oldPlayer = this.inbox.player;
      // eslint-disable-next-line vue/no-mutating-props
      this.inbox.player = '';
      // eslint-disable-next-line no-promise-executor-return
      await new Promise(resolve => setTimeout(() => resolve(true), 100));
      // eslint-disable-next-line vue/no-mutating-props
      this.inbox.player = oldPlayer;
    },
    updatedPhoneNumber(data) {
      this.$emit('updatedPhoneNumber', data);
    },
    updateInboxStatus() {
      this.$emit('updateInboxStatus');
    },
    async getCurrentPlayer() {
      const { data } = await CommonWhatsappAPI.getCurrentPlayer();
      if (!data || !data.player) {
        useAlert('Integração com Whatsapp indisponível no momento');
        return;
      }
      this.defaultPlayer = data.player;
    },
  },
};
</script>

<template>
  <div>
    <CheckConnStatus
      v-if="(!inbox.player || inbox.player === 'wppconnect') && !denyWppConn"
      v-model:phone-number="inbox.phone_number"
      @disconnected="onRerenderDisconnected"
    />
    <CommonWhatsappForm
      v-if="
        inbox.player === 'codechat' ||
        (denyWppConn && defaultPlayer === 'codechat')
      "
      default-player="codechat"
      :inbox="inbox"
      edit-mode
      @rerender="onRerender"
      @updated-phone-number="updatedPhoneNumber"
      @update-inbox-status="updateInboxStatus"
    />
  </div>
</template>
